// strip `$` and `,` but not `.` or `-`
// multiply by 100 to remove cents (e.g., $50 => 5000)
export const convertCurrencyToNumber = (currency: string): number => +(+currency.replace(/[^0-9.-]+/g, '') * 100).toFixed(0);

export const convertNumberToCurrency = (amount: number) =>
	new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(amount / 100);
